/* ============================================================
   CIELO SPORTS CLUB — Reveal & Parallax engine
   Sicherheitsmodell: jedes Element bekommt nur dann eine
   .csc-rev-init-Klasse, wenn es BELOW the fold ist UND alle
   Setup-Schritte erfolgreich waren. Above-the-fold-Elemente
   werden direkt mit .is-in markiert (sichtbar, ohne Flash).

   Parallax-Transform wird inline gesetzt — kein dauerhafter
   CSS-Scale, der bei JS-Fehler hängenbleibt.
   ============================================================ */
(function () {
  if (window.__cscRevealReady) return;
  window.__cscRevealReady = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ──────────────────────────────────────────────────────────
     Helpers
     ────────────────────────────────────────────────────────── */
  function closestOr(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }
  function isStaticContext(el) {
    /* csc-hero hat eigene Animation. shopify-section-header soll
       ebenfalls nicht generisch animiert werden. csc-poster soll
       komplett statisch sein — Bild + Inhalt sofort da, kein Entry. */
    return !!(
      closestOr(el, '.csc-hero') ||
      closestOr(el, '.csc-poster') ||
      closestOr(el, '.shopify-section-header')
    );
  }
  function alreadyTagged(el) {
    return el.hasAttribute('data-csc-reveal') || el.classList.contains('scroll-trigger');
  }
  function isInViewport(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.bottom > 0 && r.top < vh;
  }
  function parentClipsOverflow(el) {
    /* Schaut bis zu drei Levels hoch, ob ein Ahn Overflow clippt.
       Reicht für alle CSC-Sections (img → __media → section). */
    var p = el.parentElement;
    for (var i = 0; i < 3 && p; i++) {
      var cs = window.getComputedStyle(p);
      var oy = cs.overflowY;
      var ox = cs.overflowX;
      if (oy === 'hidden' || oy === 'clip' || ox === 'hidden' || ox === 'clip') return true;
      p = p.parentElement;
    }
    return false;
  }

  function splitWords(el) {
    if (el.__cscSplit) return;
    el.__cscSplit = true;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    var idx = 0;
    nodes.forEach(function (node) {
      var parent = node.parentNode;
      if (!parent) return;
      var text = node.textContent;
      if (!text || !text.trim()) return;
      var parts = text.split(/(\s+)/);
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          frag.appendChild(document.createTextNode(' '));
        } else {
          var outer = document.createElement('span');
          outer.className = 'csc-reveal__word';
          outer.style.setProperty('--i', idx++);
          var inner = document.createElement('span');
          inner.className = 'csc-reveal__word-inner';
          inner.textContent = part;
          outer.appendChild(inner);
          frag.appendChild(outer);
        }
      });
      parent.replaceChild(frag, node);
    });
  }

  /* ──────────────────────────────────────────────────────────
     1. Attribute setzen — KEIN Initial-State greift hier noch
        (.csc-rev-init wird erst in Schritt 3 gesetzt).
     ────────────────────────────────────────────────────────── */
  function tag(root) {
    root = root || document;

    /* Headlines: Wort-für-Wort hochschieben */
    var HEAD_SEL = [
      '.csc-poster__heading',
      '.csc-gather__heading',
      '.csc-feature-list__heading',
      '.csc-merch__heading',
      '.csc-event-cards__heading',
      '.csc-statement__heading',
      '.csc-icon-columns__heading',
      '.csc-court-moment__heading',
      '.csc-image-duo__heading',
      '.csc-image-band__heading',
      '.banner__heading',
      '.rich-text__heading',
      '.section-header__heading',
      '.multicolumn-card__heading',
      '.media-with-text__heading',
      'main h2.h0', 'main h2.h1',
      'main h1.h0', 'main h1.h1'
    ].join(',');
    root.querySelectorAll(HEAD_SEL).forEach(function (el) {
      if (isStaticContext(el) || alreadyTagged(el)) return;
      splitWords(el);
      el.setAttribute('data-csc-reveal', 'words');
    });

    /* Eyebrows */
    root.querySelectorAll('.csc-eyebrow, .caption-with-letter-spacing, .subtitle').forEach(function (el) {
      if (isStaticContext(el) || alreadyTagged(el)) return;
      el.setAttribute('data-csc-reveal', 'fade-up');
    });

    /* Fließtext */
    root.querySelectorAll(
      '.csc-gather__text, .rich-text__text, .csc-court-moment__text, .csc-statement__body, .csc-image-duo__text, .csc-feature-list__intro, .multicolumn-card__text'
    ).forEach(function (el) {
      if (isStaticContext(el) || alreadyTagged(el)) return;
      el.setAttribute('data-csc-reveal', 'fade-up');
    });

    /* CTAs */
    root.querySelectorAll(
      '.csc-poster__cta, .csc-gather__cta, .csc-statement__cta, .csc-feature-list__cta, .csc-merch__cta, .csc-event-cards__cta, .csc-court-moment__cta'
    ).forEach(function (el) {
      if (isStaticContext(el) || alreadyTagged(el)) return;
      el.setAttribute('data-csc-reveal', 'fade-up-delay');
    });

    /* Section-Medien: Mask-wipe + Parallax (Parallax via Inline-Transform) */
    var MEDIA_SEL = [
      '.csc-poster__image',
      '.csc-gather__image',
      '.csc-image-duo__image',
      '.csc-image-band__image',
      '.csc-court-moment__image',
      '.csc-event-card__image',
      '.media-with-text__image',
      '.image-with-text__media img',
      '.collage__item img',
      '.banner__media img'
    ].join(',');
    root.querySelectorAll(MEDIA_SEL).forEach(function (el) {
      if (isStaticContext(el)) return;
      if (!el.hasAttribute('data-csc-reveal')) el.setAttribute('data-csc-reveal', 'mask-wipe');
      /* Parallax NUR aktivieren, wenn der direkte Eltern-Container den
         Overflow clippt — sonst würde das skalierte Bild in benachbarte
         Sektionen lecken. Sicherer Default: kein Parallax. */
      if (!el.hasAttribute('data-csc-parallax') && parentClipsOverflow(el)) {
        el.setAttribute('data-csc-parallax', '0.05');
      }
    });

    /* Karten-Cascade */
    root.querySelectorAll('.csc-merch .csc-merch__card, .csc-merch__item, .csc-merch__grid > *, .grid--product-grid > .grid__item, .product-grid > .grid__item, .csc-event-cards .csc-event-card').forEach(function (el, i) {
      if (alreadyTagged(el)) return;
      el.setAttribute('data-csc-reveal', 'card');
      el.style.setProperty('--csc-card-delay', (i % 8) * 80 + 'ms');
    });

    /* Linien */
    root.querySelectorAll('.csc-line, [data-csc-line], hr').forEach(function (el) {
      if (isStaticContext(el)) return;
      el.classList.add('csc-line');
      el.setAttribute('data-csc-reveal', 'line');
    });

    /* Wordmarks — überall: Hero (zusätzlich zu eigenem Parallax),
       Footer, Statement-Logo. Mask-wipe + opacity. */
    root.querySelectorAll(
      '.csc-hero__brandmark-wordmark, .csc-footer-wordmark__shape, .csc-statement__logo, .csc-statement img[src*="cielo-wordmark"], .csc-statement img[src*="cielo-logo"], img[src*="cielo-wordmark"]'
    ).forEach(function (el) {
      if (closestOr(el, '.shopify-section-header')) return; /* Header-Logo nicht jedes Mal animieren */
      if (alreadyTagged(el)) return;
      el.setAttribute('data-csc-reveal', 'wordmark');
    });
  }

  /* ──────────────────────────────────────────────────────────
     2. IntersectionObserver
     ────────────────────────────────────────────────────────── */
  var io = null;
  function ensureObserver() {
    if (io) return io;
    if (typeof IntersectionObserver !== 'function') return null;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, {
      /* Trigger DEUTLICH vor dem sichtbaren Bereich (30 % Viewport-
         Höhe unter dem Viewport), damit Mask-wipe + Fade-up bereits
         laufen, wenn das Element tatsächlich gesehen wird. Sonst
         wirkt es wie „Bild lädt verspätet". */
      rootMargin: '0px 0px 30% 0px',
      threshold: 0
    });
    return io;
  }
  /* Sicherheits-Fallback: nach 6 s alle noch versteckten Elemente
     einblenden. Schützt vor Edge-Cases, in denen IO nicht feuert
     (z. B. lazy-Bilder ohne Layout-Box, Browser-Bugs). */
  function scheduleFallback() {
    setTimeout(function () {
      var stuck = document.querySelectorAll('.csc-rev-init:not(.is-in)');
      for (var i = 0; i < stuck.length; i++) stuck[i].classList.add('is-in');
    }, 6000);
  }

  /* ──────────────────────────────────────────────────────────
     3. .csc-rev-init nur an Elementen, die noch NICHT im
        Viewport sind. Above-the-fold-Elemente bekommen direkt
        .is-in (sichtbar ohne Animation, kein Flash).
        Trotzdem animieren wir Above-the-fold via rAF: wir setzen
        .csc-rev-init synchron + .is-in im nächsten Frame, damit
        der Browser EINEN Frame im Init-State paintet, dann
        in den Endzustand transitioned.
     ────────────────────────────────────────────────────────── */
  function setupReveal() {
    var obs = ensureObserver();
    var nodes = document.querySelectorAll('[data-csc-reveal]:not(.is-in)');
    var inView = [];
    var outOfView = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.__cscObserved) continue;
      el.__cscObserved = true;
      if (isInViewport(el)) inView.push(el);
      else outOfView.push(el);
    }

    /* Above-the-fold: init-state setzen, ein Frame painten,
       dann sanft enthüllen. */
    inView.forEach(function (el) { el.classList.add('csc-rev-init'); });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        inView.forEach(function (el) { el.classList.add('is-in'); });
      });
    });

    /* Below-the-fold: init-state setzen + beobachten. */
    outOfView.forEach(function (el) {
      el.classList.add('csc-rev-init');
      if (obs) obs.observe(el);
      else el.classList.add('is-in'); /* kein IO → einfach zeigen */
    });
  }

  /* ──────────────────────────────────────────────────────────
     4. Parallax — Transform inline, kein dauerhafter CSS-Scale.
        Wir setzen scale(1.30) NUR wenn JS parallax aktiv steuert.
     ────────────────────────────────────────────────────────── */
  /* Subtle parallax: 3% headroom (scale 1.06), Translation auf 2%
     der Höhe gedeckelt. Setzt nur Bilder in Bewegung, deren
     Container den Overflow clippt (siehe tag()-Filter). */
  var PARALLAX_SCALE = 1.06;
  var PARALLAX_MAX_RATIO = 0.02;
  var parallaxItems = [];
  function collectParallax() {
    parallaxItems = Array.prototype.slice.call(document.querySelectorAll('[data-csc-parallax]'));
    parallaxItems.forEach(function (el) {
      el.style.transformOrigin = 'center';
      el.style.willChange = 'transform';
      el.style.transform = 'translate3d(0,0,0) scale(' + PARALLAX_SCALE + ')';
    });
  }
  var ticking = false;
  function updateParallax() {
    ticking = false;
    var vh = window.innerHeight;
    for (var i = 0; i < parallaxItems.length; i++) {
      var el = parallaxItems[i];
      var rect = el.getBoundingClientRect();
      if (rect.bottom < -400 || rect.top > vh + 400) continue;
      var fromCenter = (rect.top + rect.height / 2) - vh / 2;
      var strength = parseFloat(el.dataset.cscParallax) || 0.05;
      var ty = -fromCenter * strength;
      var maxTy = rect.height * PARALLAX_MAX_RATIO;
      if (ty > maxTy) ty = maxTy;
      else if (ty < -maxTy) ty = -maxTy;
      el.style.transform = 'translate3d(0,' + ty.toFixed(1) + 'px,0) scale(' + PARALLAX_SCALE + ')';
    }
  }
  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(updateParallax);
    }
  }

  /* ──────────────────────────────────────────────────────────
     5. Init
     ────────────────────────────────────────────────────────── */
  function init() {
    try {
      tag(document);
    } catch (err) {
      /* Tagging dürfte nie crashen — wenn doch, brechen wir ab,
         CSS-Init-States greifen ohne .csc-rev-init nicht. */
      return;
    }

    if (reduced) {
      /* Reduced motion: kein init-state setzen, kein parallax. */
      document.querySelectorAll('[data-csc-reveal]').forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    setupReveal();
    collectParallax();
    updateParallax();
    scheduleFallback();
    setupLogoHoverReplay();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  /* Header-Logo: gleicher Sonnenaufgang-Effekt bei jedem Hover.
     Trick: kurz .is-replaying setzen (animation:none) → Reflow →
     wieder entfernen. Browser sieht den Animation-Wechsel als neue
     Animation und startet sie von 0% neu. */
  function setupLogoHoverReplay() {
    if (reduced) return;
    var logos = document.querySelectorAll('.header__heading-logo-wrapper');
    if (!logos.length) return;
    Array.prototype.forEach.call(logos, function (logo) {
      if (logo.__cscHoverBound) return;
      logo.__cscHoverBound = true;
      var replaying = false;
      logo.addEventListener('mouseenter', function () {
        if (replaying) return;
        replaying = true;
        logo.classList.add('is-replaying');
        /* Reflow erzwingen, sonst sieht der Browser keinen Wechsel. */
        void logo.offsetWidth;
        logo.classList.remove('is-replaying');
        /* Animation dauert 1.2s — Lockout etwas länger, damit Replay
           nicht halb durch erneut gestartet wird, wenn jemand wild
           drüber jagt. */
        setTimeout(function () { replaying = false; }, 1250);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify Theme-Editor */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      try {
        tag(e.target);
        setupReveal();
        collectParallax();
        updateParallax();
      } catch (_) {}
    });
  }
})();
